import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { API } from "aws-amplify";
import { useSelector } from "react-redux";
import { authData } from "../../../redux/auth/authSlice";
import Skeleton from "@material-ui/lab/Skeleton";
import Fade from "@material-ui/core/Fade";
// Local imports
import UserHeader from "../../Header/UserHeader/UserHeader";
import { Constants } from "../../../config/constants";
import config from "../../../config/aws-exports";
import "./ProjectDetails.scss";
import ProjectFile from "./ProjectFile";
// Styles imports
import Grade from "../GradingDetails.module.scss";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import SendIcon from "@mui/icons-material/Send";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Tabs, Box, Tab } from "@mui/material";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import { IconButton } from "@material-ui/core";
import DirectionsIcon from "@mui/icons-material/Directions";
import Select from "@mui/material/Select";
import Reply from "../../../assets/svgjs/Reply";
import "./ProjectDetails.scss";
import ProjectApprovedMessages from "./ProjectApprovedMessages";
import { ListItem } from "@material-ui/core";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: Constants.main_color_1,
      fontSize: "16px",
      color: "rgb(255,255,255)",
      fontFamily: "nunito",
    },
  },
  textFieldStyle: {
    "& > label": {
      top: "-4px !important",
      fontSize: "1.5rem",
      backgroundColor: "white",
      padding: "2px",
    },
  },
  heading: {
    fontSize: "18px",
    fontWeight: "600px",
    color: Constants.main_color_1,
    fontFamily: "nunito",
  },
  accordionStyle: {
    padding: "2rem",
    "& > div": {
      boxShadow: "#d8d8d880 0px 0px 3px 2px",
      margin: "0rem 0rem 1.5rem 0rem",
    },
    "& > div:before": {
      backgroundColor: "transparent",
    },
  },
  mainBlock: {
    margin: "0rem 0.5rem 1.5rem!important",
    boxShadow:
      "0px 0px 2px 2px rgb(0 0 0 / 10%), 0px 4px 5px 0px rgb(0 0 0 / 4%), 0px 1px 290px 0px rgb(0 0 0 / 2%)",
    "&:before": {
      backgroundColor: "white",
    },
    "& > div:first-child": {
      boxShadow: "0px 2px 2px 0px rgb(0 0 0 / 10%)",
    },
  },
}));

const ProjectGrading = () => {
  let userDetails = useSelector(authData);
  const [nuggets, setNuggets] = useState([]);
  const [objectData, setObjectData] = useState({});
  const [projectNugget, setprojectNugget] = useState([]);
  const classes = useStyles();
  let lcourseDetails = userDetails.project;

  const hiddenFileInput = React.useRef(null);
  useEffect(() => {
    getCourseDetails();
  }, []);
  async function getCourseDetails() {
    const bodyParam = {
      body: {
        btopicid: lcourseDetails.btid,
        oid: config.aws_org_id,
        topicid: lcourseDetails.tid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const courseDetails = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_COURSE_DETAILS,
        bodyParam
      );

      const topicsJSON = courseDetails?.nuggets;
      function groupByKey(array, key) {
        return array.reduce((hash, obj) => {
          if (obj[key] === undefined) return hash;
          return Object.assign(hash, {
            [obj[key]]: (hash[obj[key]] || []).concat(obj),
          });
        }, {});
      }
      var result = groupByKey(topicsJSON, "unit");
      let temp = [];
      for (let i = 0; i < topicsJSON.length; i++) {
        for (let j = 0; j < topicsJSON[i].objects.length; j++) {
          temp.push(topicsJSON[i].objects[j]);
        }
      }
      setObjectData(temp);

      setNuggets(result);
      setprojectNugget(courseDetails.nuggets);
    } catch (error) {
      console.error(error);
    }
  }

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function CourseStructure() {
    const [value, setValue] = useState();
    const [selectedFile, setSelectedFile] = useState(null);
    const [message, setMessage] = useState("");
    const [replyMessage, setReplyMessage] = useState("");
    const [errMessage, setErrMessage] = useState("");
    const [fileName, setFileName] = useState("");
    const [fileUrlName, setFileUrlName] = useState("");
    const [projectObjDetails, setProjectObjDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("");
    const [openIndex, setOpenIndex] = useState(null);
    const [showReply, setShowReply] = useState(null);
    const [fileOpen, setFileOpen] = useState(false);
    const [objFile, setObjFile] = useState();
    const [showAllMessage, setShowAllMessage] = useState(false);
    const [allMessages, setAllMessages] = useState([]);
    const [seeApprovedMessages, SetSeeApprovedMessages] = useState([]);
    const [showApprovedMessages, SetShowApprovedMessages] = useState(false);
    const [groupedMessages, setGroupedMessages] = useState([]);
    const [showCommentBox, setShowCommentBox] = useState(null);

    useEffect(() => {
      const fetchData = async () => {
        setLoading(false);
        try {
          if (value != undefined) {
            callApiRepeat(value);
          }
        } catch (err) {
          console.error(err.message);
        }
      };

      fetchData();
      const intervalId = setInterval(fetchData, 5000);
      return () => clearInterval(intervalId);
    }, [value]);
    async function callApi(tabValue) {
      setProjectObjDetails([]);
      const bodyParam = {
        body: {
          oid: config.aws_org_id,
          eid: userDetails.projectUser.col3,
          bcid: lcourseDetails.btid,
          objid: tabValue,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      setLoading(true);
      try {
        const response = await API.post(
          config.aws_cloud_logic_custom_name,
          "/getUserProjectObjects",
          bodyParam
        );
        setLoading(false);
        if (response != null || response != undefined) {
          const groupedMessages = response.reduce((acc, message) => {
            const date = message.postedDate;
            if (!acc[date]) {
              acc[date] = [];
            }
            acc[date].push(message);
            return acc;
          }, {});
          setGroupedMessages(groupedMessages);
          setProjectObjDetails(response);
          setAllMessages(response);
        }
      } catch (error) {
        console.error(error);
      }
    }
    async function callApiRepeat(tabValue) {
      const bodyParam = {
        body: {
          oid: config.aws_org_id,
          eid: userDetails.projectUser.col3,
          bcid: lcourseDetails.btid,
          objid: tabValue,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      try {
        const response = await API.post(
          config.aws_cloud_logic_custom_name,
          "/getUserProjectObjects",
          bodyParam
        );
        setLoading(false);
        if (response != null || response != undefined) {
          const groupedMessages = response.reduce((acc, message) => {
            const date = message.postedDate;
            if (!acc[date]) {
              acc[date] = [];
            }
            acc[date].push(message);
            return acc;
          }, {});

          setGroupedMessages(groupedMessages);
          setProjectObjDetails(response);
          setAllMessages(response);
        }
      } catch (error) {
        console.error(error);
      }
    }
    const handleChangeSideTab = (event, newValue, oid) => {
      setStatus("");
      setValue(newValue);
      callApi(newValue);
    };

    const handleMessageChange = (event, newValue, oid) => {
      setErrMessage("");
      setMessage(event.target.value);
    };

    async function projectObj(
      obj,
      update,
      replyobj,
      nextObj,
      curObjStatus,
      curProObj
    ) {
      let projectObj = {};

      if (update == "update") {
        projectObj = projectObjDetails;
      } else if (update == "reply") {
      } else {
        if (
          message === "" ||
          message === null ||
          (message != undefined && message.trim() === "")
        ) {
          setErrMessage("Please enter Message");
          return;
        }

        if (selectedFile != undefined) {
          if (selectedFile.size > 250 * 1024) {
            setErrMessage("file size is greater than 250kb");
            return;
          }

          let extend =
            selectedFile.name.substring(
              selectedFile.name.lastIndexOf(".") + 1,
              selectedFile.name.length
            ) || selectedFile.name;

          if (
            extend !== "JPG" &&
            extend !== "PNG" &&
            extend !== "JPEG" &&
            extend !== "jpg" &&
            extend !== "png" &&
            extend !== "jpeg" &&
            extend !== "pdf"
          ) {
            setErrMessage(
              "Please upload files in the format of pdf, jpg, jpeg, png only."
            );

            return;
          }
        }

        let pfileName = new Date().getTime();
        projectObj.id = pfileName;
        projectObj.uname = userDetails.role;
        projectObj.message = message;
        projectObj.fileName = fileName;
        projectObj.fileUrlName = fileUrlName;
      }

      const bodyParam = {
        body: {
          oid: config.aws_org_id,
          eid: userDetails.projectUser.col3,
          bcid: lcourseDetails.btid,
          projectObj: projectObj,
          replyobj: replyobj,
          objid: obj,
          type: update,
          nextObj: nextObj,
          bpid: userDetails.curprgcou.bpid,
          curObjStatus: curObjStatus,
          curProObj: curProObj,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      setLoading(true);
      try {
        await API.post(
          config.aws_cloud_logic_custom_name,
          "/updateUserProjectObjects",
          bodyParam
        );

        setLoading(false);
      } catch (error) {
        console.error(error);
      }

      setMessage("");
      setErrMessage("");
      setReplyMessage("");
      setOpenIndex(null);
      setShowReply(null);
      setErrMessage("");
      setSelectedFile(null);
      setStatus("");

      callApi(obj);
    }

    async function handleImageChange(event, oid) {
      setSelectedFile(event.target.files[0]);
      setFileName(event.target.files[0].name);
      let pfileName = new Date().getTime();
      let filename = pfileName + event.target.files[0].name;
      setFileUrlName(filename);
      let filetype = event.target.files[0].type;
      if (event.target.files[0]) {
        const bodyParam = {
          body: {
            type: "project",
            filename: filename,
            filetype: filetype,
            oid: config.aws_org_id,
            eid: userDetails.projectUser.col3,
            bcid: lcourseDetails.btid,
            objid: oid,
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        };
        setLoading(true);
        try {
          const response = await API.post(
            config.aws_cloud_logic_custom_name,
            Constants.GET_PRESIGNED_URL,
            bodyParam
          );
          fileUpload(event.target.files[0], response);
        } catch (error) {
          console.error("getCategoryError", error);
        }
      }
    }

    async function fileUpload(file, url) {
      await axios
        .put(url, file, { headers: { "Content-Type": file.type } })
        .then((res) => {
          console.error("data", JSON.stringify(res));
        })
        .catch((err) => {
          console.error(err);
        });

      setLoading(false);
    }

    const handleStatusChange = (event, proObj, object, index) => {
      setShowCommentBox(true);
      let newProObj = projectObjDetails;
      setStatus(event.target.value);
      let curObjStatus = event.target.value;
      let nextObj;

      if (event.target.value == 2) {
        let index = objectData.findIndex((obj) => obj.oid === value);

        if (objectData.length > index) {
          if (objectData[index + 1] != undefined) {
            nextObj = objectData[index + 1].oid;
          }
        }
      }

      setProjectObjDetails(newProObj);
      projectObj(object.oid, "update", "", nextObj, curObjStatus, proObj);
    };

    const handleReplyMessageChange = (event, newValue, oid) => {
      setReplyMessage(event.target.value);
    };

    const postReply = (id, postid, type) => {
      let replyobj = {};
      replyobj.id = postid;
      replyobj.uname = userDetails.role;
      replyobj.message = replyMessage;

      projectObj(id, type, replyobj);
    };

    const toggleAccordion = (index) => {
      setOpenIndex(openIndex === index ? null : index);
    };

    const toggleReply = (index) => {
      setShowReply(showReply === index ? null : index);
    };

    const toggleCommentBox = (index) => {
      setShowCommentBox(showCommentBox === index ? null : index);
    };

    function openFile(fileObj) {
      setObjFile(fileObj);
      handleFileOpen();
    }
    const handleFileOpen = () => {
      setFileOpen(true);
    };

    const handleFileClose = () => {
      setFileOpen(false);
    };

    const downloadFile = async (obj) => {
      let downloadUrl = `https://${
        Constants.DOMAIN
      }/${config.aws_org_id.toLowerCase()}-data/data/project/${
        userDetails.projectUser.col3
      }/${lcourseDetails.btid}/${value}/${obj.fileUrlName}`;

      try {
        const response = await fetch(downloadUrl);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = obj.fileName || "download";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      }
    };

    function formatDate(dateString) {
      const [day, month, year] = dateString.split("/");

      const monthIndex = parseInt(month, 10) - 1;

      const date = new Date(year, monthIndex, day);

      const formatter = new Intl.DateTimeFormat("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
      const formattedDate = formatter.format(date);
      return formattedDate;
    }
    const handleApprovedMessageOpen = () => {
      SetShowApprovedMessages(true);
    };

    const handleApprovedMessageClose = () => {
      SetShowApprovedMessages(false);
    };
    async function getProjectApprovedMessage() {
      const bodyParam = {
        body: {
          oid: config.aws_org_id,
          bpid: userDetails.curprgcou.bpid,
          tid: lcourseDetails.tid,
          btid: lcourseDetails.btid,
          eid: userDetails.projectUser.col3,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      setLoading(true);
      try {
        const response = await API.post(
          config.aws_cloud_logic_custom_name,
          "/getProjectApprovedMessage",
          bodyParam
        );

        SetSeeApprovedMessages(response);
        setLoading(false);
        handleApprovedMessageOpen();
      } catch (error) {
        console.error(error);
      }
    }

    return (
      <div className={classes.root}>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={fileOpen}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={fileOpen}>
            <ProjectFile
              handleFileClose={handleFileClose}
              obj={objFile}
              objId={value}
              bcid={lcourseDetails.btid}
              userEid={userDetails.projectUser.col3}
            />
          </Fade>
        </Modal>

        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={showApprovedMessages}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={showApprovedMessages}>
            <ProjectApprovedMessages
              handleFileClose={handleApprovedMessageClose}
              seeApprovedMessages={seeApprovedMessages}
              nuggets={nuggets}
              projectNugget={projectNugget}
              callApi={callApi}
            />
          </Fade>
        </Modal>
        <div
          style={{
            display: "grid",
            gap: "2rem",
            background: "white",
            gridTemplateColumns: "12rem 12rem",
            padding: "3rem",
          }}
        >
          <h4>Name</h4>
          <h4>{userDetails.projectUser.col1}</h4>

          <h4>Email ID</h4>
          <h4>{userDetails.projectUser.col2}</h4>
        </div>

        <div
          style={{
            boxShadow: "#d8d8d880 0px 0px 3px 2px",
            backgroundColor: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "white",
              marginTop: "2rem",
              padding: "2rem",
              alignItems: "center",
            }}
          >
            <h3 style={{ fontWeight: "700" }}>{lcourseDetails.ttitle}</h3>

            {loading ? (
              <Skeleton style={{ width: "100%", margin: "20px" }} />
            ) : (
              <div></div>
            )}
          </div>

          {userDetails.projectUser.col5 != undefined ||
          userDetails.projectUser.col5 != "-" ? (
            <div className={classes.accordionStyle}>
              {Object.keys(nuggets).map((nugget, idx) => (
                <>
                  {nuggets[nugget].map(
                    (
                      { nid, unit, ntitle, nduration, objects, nenabled },
                      idx
                    ) => (
                      <Accordion className={classes.mainBlock}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <Typography className={classes.heading}>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                              }}
                            >
                              <h3
                                className="item"
                                style={{
                                  fontWeight: "bold",

                                  color:
                                    userDetails.projectUser &&
                                    userDetails.projectUser.col11 &&
                                    userDetails.projectUser.col11.nid == nid
                                      ? "#e35f14"
                                      : "black",
                                }}
                              >
                                {ntitle}
                              </h3>
                              {userDetails.projectUser &&
                              userDetails.projectUser.col11 &&
                              userDetails.projectUser.col11.nid == nid ? (
                                <AccessTimeIcon
                                  style={{
                                    height: "20px",
                                    width: "20px",
                                    color: "#e35f14",
                                  }}
                                />
                              ) : (
                                <></>
                              )}
                            </div>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ display: "block" }}>
                          <Typography>
                            <div>
                              {lcourseDetails?.coursetype == "Project" ? (
                                <Box
                                  sx={{
                                    flexGrow: 1,
                                    bgcolor: "background.paper",
                                    display: "flex",
                                  }}
                                >
                                  <Tabs
                                    orientation="vertical"
                                    variant="scrollable"
                                    value={value}
                                    onChange={handleChangeSideTab}
                                    aria-label="Vertical tabs example"
                                    sx={{
                                      borderRight: 1,
                                      borderColor: "divider",
                                    }}
                                    style={{ width: "27rem" }}
                                  >
                                    {objects.map(
                                      ({
                                        oid,
                                        otitle,
                                        odescription,
                                        otype,
                                        oduration,
                                        ourl,
                                        userOP,
                                      }) => (
                                        <Tab
                                          key={oid}
                                          label={
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "10px",
                                                width: "100%",
                                                justifyContent: "Space-between",
                                                textTransform: "capitalize",
                                                alignItems: "center",
                                                color: "black",
                                              }}
                                            >
                                              <p
                                                style={{
                                                  fontWeight: "500",
                                                  fontSize: "16px",
                                                  textAlign: "left",
                                                }}
                                              >
                                                {otitle}
                                              </p>
                                            </div>
                                          }
                                          value={oid}
                                          style={{
                                            fontSize: "12px",
                                            alignItems: "start",
                                          }}
                                        />
                                      )
                                    )}
                                  </Tabs>

                                  {loading ? (
                                    <Skeleton
                                      style={{ width: "100%", margin: "20px" }}
                                    />
                                  ) : (
                                    <>
                                      {objects.map((object, index) => (
                                        <TabPanel
                                          key={index}
                                          value={value}
                                          index={object.oid}
                                          style={{ width: "100%" }}
                                        >
                                          <div
                                            style={{
                                              border: "1px solid lightgray",
                                              overflow: "hidden",
                                              borderRadius: "8px",
                                              marginBottom: "2rem",
                                            }}
                                          >
                                            <div
                                              className="Project_Side"
                                              style={{
                                                display: "flex",
                                                backgroundColor: "#2f6eb2",
                                                justifyContent: "SpaceBetween",
                                                color: "white",
                                              }}
                                            >
                                              <h3 style={{ padding: "1rem" }}>
                                                {object.otitle}
                                              </h3>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  gap: "10px",
                                                  alignItems: "center",
                                                  padding: "1rem",
                                                }}
                                              >
                                                <DirectionsIcon />

                                                {showAllMessage ? (
                                                  <h3
                                                    style={{
                                                      textDecoration:
                                                        "underline",
                                                      cursor: "pointer",
                                                      fontSize: "1.4rem",
                                                    }}
                                                    onClick={() => {
                                                      setShowAllMessage(false);
                                                      setProjectObjDetails(
                                                        allMessages
                                                      );
                                                    }}
                                                  >
                                                    See All message
                                                  </h3>
                                                ) : (
                                                  <h3
                                                    style={{
                                                      textDecoration:
                                                        "underline",
                                                      cursor: "pointer",
                                                      fontSize: "1.4rem",
                                                    }}
                                                    onClick={() => {
                                                      getProjectApprovedMessage();
                                                    }}
                                                  >
                                                    See approved message
                                                  </h3>
                                                )}
                                              </div>
                                            </div>

                                            {projectObjDetails == undefined ||
                                            projectObjDetails.length == 0 ? (
                                              <></>
                                            ) : (
                                              <>
                                                <div>
                                                  {Object.keys(
                                                    groupedMessages
                                                  ).map((date) => (
                                                    <div key={date}>
                                                      <div
                                                        style={{
                                                          position: "relative",
                                                          borderBottom:
                                                            "1px solid lightgray",
                                                          margin: "2rem 0rem",
                                                        }}
                                                      >
                                                        <p
                                                          style={{
                                                            position:
                                                              "absolute",
                                                            left: "42%",
                                                            top: "-1.5rem",
                                                            background: "white",
                                                            padding:
                                                              "0.5rem 3rem",
                                                            borderRadius:
                                                              "4rem",
                                                            border:
                                                              "1px solid lightgray",
                                                            fontSize: "1.3rem",
                                                          }}
                                                        >
                                                          {formatDate(date)}
                                                        </p>
                                                      </div>
                                                      {groupedMessages[
                                                        date
                                                      ].map((projectobj) => (
                                                        <div>
                                                          <div
                                                            style={{
                                                              borderLeft:
                                                                projectobj.objStatus ==
                                                                2
                                                                  ? "3px solid #01a71b"
                                                                  : "",

                                                              backgroundColor:
                                                                projectobj.objStatus ==
                                                                2
                                                                  ? "#d9f8db"
                                                                  : "",

                                                              borderBottom:
                                                                "1px solid #cecece",

                                                              borderRadius:
                                                                "5px",
                                                            }}
                                                          >
                                                            <ListItem alignItems="flex-start">
                                                              <ListItemAvatar>
                                                                <Avatar
                                                                  style={{
                                                                    fontSize:
                                                                      "14px",

                                                                    backgroundColor:
                                                                      projectobj.uname
                                                                        .charAt(
                                                                          0
                                                                        )
                                                                        .toUpperCase() ===
                                                                      "A"
                                                                        ? "#f44336"
                                                                        : projectobj.uname
                                                                            .charAt(
                                                                              0
                                                                            )
                                                                            .toUpperCase() ===
                                                                          "I"
                                                                        ? "#007bff"
                                                                        : "#ffa200",
                                                                  }}
                                                                >
                                                                  {projectobj.uname
                                                                    .charAt(0)
                                                                    .toUpperCase()}
                                                                </Avatar>
                                                              </ListItemAvatar>
                                                              <ListItemText
                                                                style={{
                                                                  display:
                                                                    "block",
                                                                }}
                                                                primary={
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "14px",
                                                                      fontWeight:
                                                                        "500",
                                                                      marginBottom:
                                                                        "9px",
                                                                      color:
                                                                        "#333333",
                                                                      overflow:
                                                                        "auto",
                                                                    }}
                                                                  >
                                                                    {
                                                                      projectobj.uname
                                                                    }
                                                                  </p>
                                                                }
                                                                secondary={
                                                                  <div
                                                                    style={{
                                                                      fontSize:
                                                                        "16px",
                                                                      color:
                                                                        "black",
                                                                    }}
                                                                  >
                                                                    <div
                                                                      style={{
                                                                        marginBottom:
                                                                          "2rem",
                                                                      }}
                                                                    >
                                                                      <p
                                                                        style={{
                                                                          marginBottom:
                                                                            "1rem",
                                                                        }}
                                                                      >
                                                                        {
                                                                          projectobj.message
                                                                        }
                                                                      </p>

                                                                      {projectobj.fileName && (
                                                                        <div
                                                                          style={{
                                                                            display:
                                                                              "flex",
                                                                            gap: "1rem",

                                                                            alignItems:
                                                                              "center",
                                                                            marginBottom:
                                                                              "7px",
                                                                          }}
                                                                        >
                                                                          <p
                                                                            style={{
                                                                              fontSize:
                                                                                "12px",
                                                                            }}
                                                                          >
                                                                            {
                                                                              projectobj.fileName
                                                                            }
                                                                          </p>

                                                                          <div>
                                                                            <VisibilityIcon
                                                                              style={{
                                                                                width:
                                                                                  "20px",
                                                                                height:
                                                                                  "20px",
                                                                                marginRight:
                                                                                  "5px",
                                                                                cursor:
                                                                                  "pointer",
                                                                              }}
                                                                              onClick={() => {
                                                                                openFile(
                                                                                  projectobj
                                                                                );
                                                                              }}
                                                                            />

                                                                            <DownloadIcon
                                                                              style={{
                                                                                width:
                                                                                  "20px",
                                                                                height:
                                                                                  "20px",
                                                                                marginRight:
                                                                                  "5px",
                                                                                cursor:
                                                                                  "pointer",
                                                                              }}
                                                                              onClick={() => {
                                                                                downloadFile(
                                                                                  projectobj
                                                                                );
                                                                              }}
                                                                            />
                                                                          </div>
                                                                        </div>
                                                                      )}

                                                                      <div
                                                                        style={{
                                                                          display:
                                                                            "flex",
                                                                          gap: "10px",
                                                                          alignItems:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        <div>
                                                                          <IconButton
                                                                            edge="end"
                                                                            onClick={() =>
                                                                              toggleReply(
                                                                                projectobj.id
                                                                              )
                                                                            }
                                                                          >
                                                                            <Reply className="replyIcon" />
                                                                          </IconButton>
                                                                        </div>
                                                                        <p>
                                                                          reply
                                                                        </p>
                                                                        <p>
                                                                          {projectobj.reply ==
                                                                            undefined ||
                                                                          projectobj
                                                                            .reply
                                                                            .length ==
                                                                            0 ? (
                                                                            <>

                                                                            </>
                                                                          ) : (
                                                                            <div
                                                                              style={{
                                                                                display:
                                                                                  "flex",
                                                                                gap: "10px",
                                                                              }}
                                                                            >
                                                                              <p>
                                                                                |
                                                                              </p>

                                                                              <a
                                                                                style={{
                                                                                  textDecoration:
                                                                                    "underline",
                                                                                  cursor:
                                                                                    "pointer",
                                                                                }}
                                                                                href
                                                                                onClick={() =>
                                                                                  toggleAccordion(
                                                                                    projectobj.id
                                                                                  )
                                                                                }
                                                                              >
                                                                                {
                                                                                  projectobj
                                                                                    .reply
                                                                                    .length
                                                                                }
                                                                              </a>

                                                                              <p>
                                                                                reply
                                                                              </p>
                                                                            </div>
                                                                          )}
                                                                        </p>

                                                                        <p>|</p>

                                                                        {projectobj.uname ==
                                                                          "Admin" ||
                                                                        projectobj.uname ==
                                                                          "Instructors" ? (
                                                                          <></>
                                                                        ) : (
                                                                          <div>
                                                                            <FormControl
                                                                              style={{
                                                                                width:
                                                                                  "20rem",
                                                                              }}
                                                                            >
                                                                              <InputLabel
                                                                                id="demo-simple-select-label"
                                                                                style={{
                                                                                  padding:
                                                                                    "0px 8px",
                                                                                  background:
                                                                                    "white",
                                                                                  fontSize:
                                                                                    "1.5rem",
                                                                                }}
                                                                              >
                                                                                Approval
                                                                                Status
                                                                              </InputLabel>
                                                                              <Select
                                                                                labelId="demo-simple-select-label"
                                                                                id="demo-simple-select"
                                                                                value={
                                                                                  projectobj.objStatus ==
                                                                                  undefined
                                                                                    ? status
                                                                                    : projectobj.objStatus
                                                                                }
                                                                                label="Age"
                                                                                onChange={(
                                                                                  e
                                                                                ) => {
                                                                                  handleStatusChange(
                                                                                    e,
                                                                                    projectobj,
                                                                                    object,
                                                                                    index
                                                                                  );
                                                                                  toggleCommentBox(
                                                                                    projectobj.id
                                                                                  );
                                                                                }}
                                                                              >
                                                                                <MenuItem
                                                                                  value={
                                                                                    2
                                                                                  }
                                                                                  style={{
                                                                                    justifyContent:
                                                                                      "center",
                                                                                    textAlign:
                                                                                      "left",
                                                                                  }}
                                                                                >
                                                                                  <div
                                                                                    style={{
                                                                                      display:
                                                                                        "flex",
                                                                                      gap: "1rem",
                                                                                      color:
                                                                                        "green",
                                                                                    }}
                                                                                  >
                                                                                    <DoneIcon
                                                                                      style={{
                                                                                        height:
                                                                                          "2rem",
                                                                                        width:
                                                                                          "2rem",
                                                                                      }}
                                                                                    />

                                                                                    <h4
                                                                                      style={{
                                                                                        width:
                                                                                          "8rem",
                                                                                      }}
                                                                                    >
                                                                                      Approved
                                                                                    </h4>
                                                                                  </div>
                                                                                </MenuItem>
                                                                                <MenuItem
                                                                                  style={{
                                                                                    justifyContent:
                                                                                      "center",
                                                                                  }}
                                                                                  value={
                                                                                    3
                                                                                  }
                                                                                >
                                                                                  <div
                                                                                    style={{
                                                                                      display:
                                                                                        "flex",
                                                                                      gap: "1rem",
                                                                                      color:
                                                                                        "red",
                                                                                    }}
                                                                                  >
                                                                                    <ClearIcon
                                                                                      style={{
                                                                                        height:
                                                                                          "2rem",
                                                                                        width:
                                                                                          "2rem",
                                                                                      }}
                                                                                    />

                                                                                    <h4
                                                                                      style={{
                                                                                        width:
                                                                                          "8rem",
                                                                                      }}
                                                                                    >
                                                                                      Reject
                                                                                    </h4>
                                                                                  </div>
                                                                                </MenuItem>

                                                                                <MenuItem
                                                                                  style={{
                                                                                    justifyContent:
                                                                                      "center",
                                                                                  }}
                                                                                  value={
                                                                                    1
                                                                                  }
                                                                                >
                                                                                  <div
                                                                                    style={{
                                                                                      display:
                                                                                        "flex",
                                                                                      gap: "1rem",
                                                                                      color:
                                                                                        "orange",
                                                                                    }}
                                                                                  >
                                                                                    <AccessTimeIcon
                                                                                      style={{
                                                                                        height:
                                                                                          "2rem",
                                                                                        width:
                                                                                          "2rem",
                                                                                      }}
                                                                                    />
                                                                                    <h4
                                                                                      style={{
                                                                                        width:
                                                                                          "8rem",
                                                                                      }}
                                                                                    >
                                                                                      Inprogress
                                                                                    </h4>
                                                                                  </div>
                                                                                </MenuItem>
                                                                              </Select>
                                                                            </FormControl>
                                                                          </div>
                                                                        )}
                                                                      </div>

                                                                      {(showReply ===
                                                                        index ||
                                                                        showReply ===
                                                                          projectobj.id) && (
                                                                        <div>
                                                                          <ListItem alignItems="flex-start">
                                                                            <ListItemAvatar>
                                                                              <Avatar
                                                                                style={{
                                                                                  fontSize:
                                                                                    "14px",

                                                                                  backgroundColor:
                                                                                    userDetails.role
                                                                                      .charAt(
                                                                                        0
                                                                                      )
                                                                                      .toUpperCase() ===
                                                                                    "A"
                                                                                      ? "#f44336"
                                                                                      : userDetails.role
                                                                                          .charAt(
                                                                                            0
                                                                                          )
                                                                                          .toUpperCase() ===
                                                                                        "I"
                                                                                      ? "#007bff"
                                                                                      : "#ffa200",
                                                                                }}
                                                                              >
                                                                                {userDetails.role
                                                                                  .charAt(
                                                                                    0
                                                                                  )
                                                                                  .toUpperCase()}
                                                                              </Avatar>
                                                                            </ListItemAvatar>
                                                                            <ListItemText
                                                                              style={{
                                                                                display:
                                                                                  "block",
                                                                              }}
                                                                              primary={
                                                                                <p
                                                                                  style={{
                                                                                    fontSize:
                                                                                      "small",
                                                                                    color:
                                                                                      "#3372B5",
                                                                                    marginBottom:
                                                                                      "5px",
                                                                                  }}
                                                                                >
                                                                                  {
                                                                                    userDetails.role
                                                                                  }
                                                                                </p>
                                                                              }
                                                                              secondary={
                                                                                <OutlinedInput
                                                                                  style={{
                                                                                    margin:
                                                                                      "15px",
                                                                                    width:
                                                                                      "97%",
                                                                                    fontSize:
                                                                                      "14px",
                                                                                  }}
                                                                                  placeholder="Reply..."
                                                                                  value={
                                                                                    replyMessage
                                                                                  }
                                                                                  onChange={(
                                                                                    e
                                                                                  ) => {
                                                                                    handleReplyMessageChange(
                                                                                      e
                                                                                    );
                                                                                  }}
                                                                                  endAdornment={
                                                                                    <InputAdornment position="end">
                                                                                      <IconButton edge="end">
                                                                                        <SendIcon
                                                                                          style={{
                                                                                            color:
                                                                                              "#3372b5",
                                                                                            height:
                                                                                              "2.5rem",
                                                                                            width:
                                                                                              "2.5rem",
                                                                                          }}
                                                                                          onClick={() => {
                                                                                            postReply(
                                                                                              object.oid,
                                                                                              projectobj.id,
                                                                                              "reply"
                                                                                            );
                                                                                          }}
                                                                                        />
                                                                                      </IconButton>
                                                                                    </InputAdornment>
                                                                                  }
                                                                                />
                                                                              }
                                                                            />
                                                                          </ListItem>
                                                                        </div>
                                                                      )}

                                                                      {projectobj.reply ==
                                                                        undefined ||
                                                                      projectobj
                                                                        .reply
                                                                        .length ==
                                                                        0 ? (
                                                                        <></>
                                                                      ) : (
                                                                        <>
                                                                          {projectobj.reply.map(
                                                                            (
                                                                              reply,
                                                                              index
                                                                            ) => (
                                                                              <div
                                                                                key={
                                                                                  index
                                                                                }
                                                                                className="accordion"
                                                                              >
                                                                                {(openIndex ===
                                                                                  index ||
                                                                                  openIndex ===
                                                                                    projectobj.id) && (
                                                                                  <div
                                                                                    className="accordion-content"
                                                                                    style={{
                                                                                      width:
                                                                                        "60%",
                                                                                    }}
                                                                                  >
                                                                                    <ListItem alignItems="flex-start">
                                                                                      <ListItemAvatar>
                                                                                        <Avatar
                                                                                          style={{
                                                                                            fontSize:
                                                                                              "14px",

                                                                                            backgroundColor:
                                                                                              reply.uname
                                                                                                .charAt(
                                                                                                  0
                                                                                                )
                                                                                                .toUpperCase() ===
                                                                                              "A"
                                                                                                ? "#f44336"
                                                                                                : reply.uname
                                                                                                    .charAt(
                                                                                                      0
                                                                                                    )
                                                                                                    .toUpperCase() ===
                                                                                                  "I"
                                                                                                ? "#007bff"
                                                                                                : "#ffa200",
                                                                                          }}
                                                                                        >
                                                                                          {reply.uname
                                                                                            .charAt(
                                                                                              0
                                                                                            )
                                                                                            .toUpperCase()}
                                                                                        </Avatar>
                                                                                      </ListItemAvatar>
                                                                                      <ListItemText
                                                                                        style={{
                                                                                          display:
                                                                                            "block",
                                                                                        }}
                                                                                        primary={
                                                                                          <p
                                                                                            style={{
                                                                                              fontSize:
                                                                                                "small",
                                                                                              color:
                                                                                                "#3372B5",
                                                                                              marginBottom:
                                                                                                "5px",
                                                                                            }}
                                                                                          >
                                                                                            {
                                                                                              reply.uname
                                                                                            }
                                                                                          </p>
                                                                                        }
                                                                                        secondary={
                                                                                          <div
                                                                                            style={{
                                                                                              fontSize:
                                                                                                "medium",
                                                                                            }}
                                                                                          >
                                                                                            {
                                                                                              reply.message
                                                                                            }
                                                                                          </div>
                                                                                        }
                                                                                      />
                                                                                    </ListItem>
                                                                                    <hr />
                                                                                  </div>
                                                                                )}
                                                                              </div>
                                                                            )
                                                                          )}
                                                                        </>
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                }
                                                              />
                                                            </ListItem>
                                                          </div>
                                                        </div>
                                                      ))}
                                                    </div>
                                                  ))}
                                                </div>
                                              </>
                                            )}

                                            <OutlinedInput
                                              style={{
                                                margin: "15px",
                                                width: "97%",
                                                fontSize: "14px",
                                              }}
                                              placeholder="Message..."
                                              value={message}
                                              onChange={(e) => {
                                                handleMessageChange(e);
                                              }}
                                              endAdornment={
                                                <InputAdornment position="end">
                                                  <div
                                                    style={{
                                                      fontSize: "14px",
                                                    }}
                                                  >
                                                    <input
                                                      className={classes.hidden}
                                                      accept="image/*,application/pdf,"
                                                      type="file"
                                                      onChange={(e) => {
                                                        handleImageChange(
                                                          e,
                                                          object.oid
                                                        );
                                                      }}
                                                      ref={hiddenFileInput}
                                                      style={{
                                                        display: "none",
                                                      }}
                                                    />

                                                    <Avatar
                                                      style={{
                                                        background:
                                                          "transparent",

                                                        cursor: "pointer",
                                                      }}
                                                      onClick={handleClick}
                                                    >
                                                      <AttachFileIcon
                                                        style={{
                                                          rotate: "none",
                                                          transform:
                                                            "rotate(30deg)",
                                                          color: "#3f51b5",
                                                          height: "2.5rem",
                                                          width: "2.5rem",
                                                        }}
                                                      />
                                                    </Avatar>

                                                    <Typography
                                                      className={classes.title}
                                                      variant="h6"
                                                    ></Typography>
                                                    <p
                                                      style={{
                                                        fontSize: "12px",
                                                        fontWeight: "bold",
                                                        paddingLeft: "3%",
                                                      }}
                                                    ></p>
                                                  </div>
                                                  <IconButton edge="end">
                                                    <SendIcon
                                                      style={{
                                                        color: "#3372b5",
                                                        height: "2.5rem",
                                                        width: "2.5rem",
                                                      }}
                                                      onClick={() => {
                                                        projectObj(
                                                          object.oid,
                                                          "updateMessage"
                                                        );
                                                      }}
                                                    />
                                                  </IconButton>
                                                </InputAdornment>
                                              }
                                            />

                                            {selectedFile && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  gap: "5px",
                                                  fontSize: "12px",

                                                  padding: "5px",
                                                  margin: "0 0 10px 20px",
                                                }}
                                              >
                                                <p>{selectedFile.name}</p>

                                                <CloseIcon
                                                  style={{
                                                    color: "red",
                                                    cursor: "pointer",
                                                    height: "2rem",
                                                    width: "2rem",
                                                  }}
                                                  onClick={() => {
                                                    setSelectedFile(null);
                                                    setErrMessage("");
                                                  }}
                                                />
                                              </div>
                                            )}

                                            {errMessage && (
                                              <p
                                                style={{
                                                  color: "red",
                                                  margin: "0 0 10px 20px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                {errMessage}
                                              </p>
                                            )}
                                          </div>
                                        </TabPanel>
                                      ))}
                                    </>
                                  )}
                                </Box>
                              ) : (
                                <></>
                              )}
                            </div>
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    )
                  )}
                </>
              ))}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={Grade.maincontainer}>
      <UserHeader Bindex={3} />
      <CourseStructure />
    </div>
  );
};

export default ProjectGrading;
